document.addEventListener('DOMContentLoaded', function() {
    let loading = false;
    let currentPage = 1;
    let maxPages = parseInt(document.querySelector('.kev-pagination').dataset.maxPages);

    window.onscroll = function() {
        if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 600 && !loading && currentPage < maxPages) {
            loading = true;
            currentPage++;
            loadMoreProducts(currentPage);
        }
    };
      
    function loadMoreProducts(page) {
        const url = new URL(window.location.href);
        url.searchParams.set('page', page);
        fetch(url)
            .then(response => response.text())
            .then(data => {
                const parser = new DOMParser();
                const newDocument = parser.parseFromString(data, 'text/html');
                const newProducts = newDocument.querySelector('.collection-products');
                const target = document.querySelector('.collection-products');
                target.insertAdjacentHTML('beforeend', newProducts.innerHTML);

const filters = document.querySelectorAll('.collection-filter');
        filters.forEach((filter, index) => {
            if (index > 0) {
                filter.style.display = 'none';
            }
        });
                // Manually trigger lazy loading for new images
                target.querySelectorAll('image-element').forEach(img => {
                    img.classList.remove('lazyload');
                    img.classList.add('aos-init');
                    img.classList.add('aos-animate');
                    img.src = img.dataset.src;
                                    console.log(img); 
                });

                loading = false;
            })
            .catch(error => {
                console.error('Error loading more products:', error);
                loading = false;
            });
    }
});
